import { each, equals, equals2, flatMap, go, last } from "fxjs/es";
import { PathEditorNS } from "../../../../../../PathEditor/PathEditorNS.js";
export const insertCuttingLinePathEditorBefore = (
  self,
  { ref_command, makePathEditor }
) => {
  self._checkIsPathEditing();
  const path_editor_layer_el = self._getPathEditorLayerElThrowable();
  const path_editor_line_container_el =
    self._getPathEditorLineContainerElThrowable();
  const outer_cutting_line_clip_path_el =
    self._getOuterCuttingLineClipPathElThrowable();
  const outer_cutting_line_display_path_el =
    self._getOuterCuttingLineDisplayPathElThrowable();
  const path_editor_point_size_controller =
    self._getPathEditorPointSizeControllerThrowable();
  const getPathElCTM = () => {
    const ctm = outer_cutting_line_display_path_el.getCTM();
    if (ctm == null) {
      throw new Error(
        `cutting_line_display_path 엘리먼트의 CTM 을 구할 수 없습니다.`
      );
    }
    return ctm;
  };
  const getPathEditorLayerElCTM = () => {
    const ctm = path_editor_layer_el.getCTM();
    if (ctm == null) {
      throw new Error(`path_editor_layer 엘리먼트의 CTM 을 구할 수 없습니다.`);
    }
    return ctm;
  };
  const { model, view, point_el_list, line_el_list } = makePathEditor({
    svg_el: self._svg_el,
    document: self._document,
    path_editor_point_size_controller,
    getPathElCTM,
    getPathEditorLayerElCTM,
  });
  const ref_path_editor_idx = self._path_editor_list.findIndex(({ model }) =>
    equals(model)(ref_command)
  );
  if (ref_path_editor_idx < 0) {
    throw new Error(`기준 패스를 찾을 수 없습니다.`);
  }
  if (equals2(ref_path_editor_idx)(0)) {
    throw new Error(`첫 번째 패스에는 추가할 수 없습니다.`);
  }
  const next_path_editor = self._path_editor_list[ref_path_editor_idx];
  if (next_path_editor == null) {
    throw new Error(`이전 패스를 찾을 수 없습니다.`);
  }
  const next_command = next_path_editor.model;
  const next_view = next_path_editor.view;
  const prev_path_editor = self._path_editor_list[ref_path_editor_idx - 1];
  if (prev_path_editor == null) {
    throw new Error(`이전 패스를 찾을 수 없습니다.`);
  }
  const prev_command = prev_path_editor.model;
  next_command.setPrevCommand(null);
  model.setPrevCommand(prev_command);
  next_command.setPrevCommand(model);
  next_view.insertNodesBeforeSelf(point_el_list);
  each((line_el) => path_editor_line_container_el.appendChild(line_el))(
    line_el_list
  );
  self._path_editor_list = flatMap((path_editor) =>
    equals(path_editor)(prev_path_editor)
      ? [
          prev_path_editor,
          {
            model,
            view,
          },
        ]
      : [path_editor]
  )(self._path_editor_list);
  const d = go(
    self._path_editor_list,
    last,
    (a) => a?.model,
    (m) => m?.toString()
  );
  if (d == null) {
    throw new Error(`패스의 경로를 계산할 수 없습니다.`);
  }
  self._outer_cutting_line_path_data = d;
  outer_cutting_line_clip_path_el.setAttributeNS(null, "d", d);
  outer_cutting_line_display_path_el.setAttributeNS(null, "d", d);
  outer_cutting_line_clip_path_el.dispatchEvent(
    new CustomEvent("@mp/sticker-editor/outer-cutting-line-changed", {
      bubbles: true,
      cancelable: true,
      composed: false,
      detail: {
        path_data: d,
      },
    })
  );
};
